module.exports = __webpack_public_path__ + "9f0dc2e284e9ebbd5ba93ac107a982a6.svg";